import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CountryResponse } from "../../types/country";
import { getCountries } from "../thunks/countryThunks";

interface CountryState {
  countries: CountryResponse[];
  country:CountryResponse;
  loading: boolean;
  error: string | null;
  success: string | null;
}

const initialState: CountryState = {
  countries: [],
  country:null,
  loading: false,
  error: null,
  success: null,
};

export const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    // optional manual setters if you still want to update state directly
    setCountries: (state, action:PayloadAction<CountryResponse[]>) => {
      state.countries = action.payload;
    },
       setCountry: (state, action:PayloadAction<CountryResponse>) => {
      state.country = action.payload;
    },
    setLoading: (state, action:PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action:PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCountries.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        state.loading = false;
        state.countries = action.payload;
        state.success = "Countries loaded successfully";
      })
      .addCase(getCountries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  },
});

export const { setCountries, setError,setCountry,setLoading } = countrySlice.actions;

export default countrySlice.reducer;

